import React, { FC, ReactNode } from 'react';

interface FieldButtonWithIcon {
  onClick: () => void;
  icon?: ReactNode;
}

export const FieldButtonWithIcon: FC<FieldButtonWithIcon> = ({ onClick, icon }) => {
  return (
    <button
      onClick={onClick}
      className='self-stretch h-full focus:outline-none focus-visible:shadow-outline'
      data-testid='button-field-with-icon'
    >
      {icon}
    </button>
  );
};
